import type { Pivot } from '@empathyco/playboard-core-domain'
import type { Ref } from 'vue'
import type { RegularFilterSelectedValues } from '../../models'
import type { DomainServiceProvider } from '../../providers/interfaces/domain-service.provider'
import type { IToolingBaseComposableDataItem } from '../use-tooling-base/types'
import type { IToolingFormComposableData } from './types'
import { ref } from 'vue'
import { CONTAINER } from '../../config/inversify.config'
import { TYPES } from '../../config/inversify.types'
import { useFeature } from '../use-feature'

export const dataFn = <
  DataItemType extends IToolingBaseComposableDataItem,
>(): IToolingFormComposableData<DataItemType> => {
  const { featureId } = useFeature()

  const getInitialItem = (): DataItemType => {
    const domainService = CONTAINER.get<DomainServiceProvider<DataItemType>>(
      TYPES.DomainServiceProvider,
    )(featureId.value)
    return domainService.getEmptyInstance()
  }

  const item = ref(getInitialItem()) as Ref<DataItemType>

  const pivotable = ref<Array<Pivot>>(item.value.criteria.pivots ?? [])

  const previewFiltersSelectedValues = ref<Record<string, RegularFilterSelectedValues>>({})

  return {
    item,
    pivotable,
    previewFiltersSelectedValues,
  }
}
